import { Modal, Tooltip, Table, Form } from 'antd';
import React, { useState, useEffect } from 'react';
import { Button, } from '@digital/ui';
import { getAllTaskBackgroundCrf, ITaskBackgroundCrf } from '@app/api/crf/crfTaskBackgroundCrf'
import { mountFormFilterDropDown } from '@app/components/FormFilterDropDown';



const ModalProcessoAtualizacaoADistribuir = () => {

    const [exibirModal, setExibirModal] = useState(false)
    const [result, setResult] = useState<Array<ITaskBackgroundCrf>>();



    useEffect(() => {
        hasGetAll();
    }, []);

    useEffect(() => {
        if (exibirModal) {
            hasGetAll();
        } else {
            setResult([])
        }
    }, [exibirModal]);

    const hasGetAll = () => {
        getAllTaskBackgroundCrf().then((result) => {
            if (result) {
                result.map((value, index) => {
                    value.numeroLinha = index + 1;
                })
                setResult(result)
            }
        })
    }

    const showModal = () => {

        setExibirModal(true);
    };

    const handleCancel = () => {
        setExibirModal(false);
    };



    return (
        <>
            <Tooltip title="Rotina Atualização ADistribuir">
                <Button
                    onClick={showModal}
                    icon="commons-download_2"
                >
                    Rotina Atualização ADistribuir
                </Button>
            </Tooltip>
            <Modal
                width={600}
                title="Processo Atualização ADistribuir"
                className="chat-modal"
                visible={exibirModal}
                onCancel={() => {
                    handleCancel();
                }}
                footer={[
                    <Button key="submit" type="primary" icon="commons-cancel" onClick={() => handleCancel()}>
                        Fechar
                    </Button>,
                ]}>

                <div className="chat-modal-message-box">
                    <Form>
                        <Form.Item>
                            <Table
                                columns={
                                    [
                                        {
                                            title: 'N',
                                            dataIndex: 'numeroLinha',
                                        },
                                        {
                                            title: 'Descrição',
                                            dataIndex: 'descricaoTask',
                                            ...mountFormFilterDropDown('descricaoTask', 'Pesquisar')
                                        },
                                        {
                                            title: 'status',
                                            dataIndex: 'status',
                                            ...mountFormFilterDropDown('status', 'Pesquisar')
                                        },
                                    ]

                                }
                                dataSource={result}
                            />
                        </Form.Item>
                    </Form>
                </div>
            </Modal>
        </>
    );
};

export default ModalProcessoAtualizacaoADistribuir;
